import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut, onAuthStateChanged } from 'firebase/auth';
import { getFirestore, doc, getDocFromServer, collection, query, where, getDocs, setDoc, serverTimestamp, updateDoc, deleteDoc } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
const firebaseConfig = {
  apiKey: "AIzaSyATLnsYb1c8Jj5EoNTIK0A_2X3Y4sfAbm8",
  authDomain: "sebahotnews-m.firebaseapp.com",
  projectId: "sebahotnews-m",
  storageBucket: "sebahotnews-m.firebasestorage.app",
  messagingSenderId: "404929563583",
  appId: "1:404929563583:web:72c060128c0bb16e206f0a",
  measurementId: "G-WM91SV1YJE"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('https://www.googleapis.com/auth/blogger');

let cachedAccessToken: string | null = typeof window !== 'undefined' ? localStorage.getItem('blogger_oauth_token') : null;

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const credential = GoogleAuthProvider.credentialFromResult(result);
    if (credential?.accessToken) {
      cachedAccessToken = credential.accessToken;
      localStorage.setItem('blogger_oauth_token', credential.accessToken);
    }
    return result.user;
  } catch (error: any) {
    if (error.code !== 'auth/cancelled-popup-request' && error.code !== 'auth/popup-closed-by-user') {
      console.error('Error signing in with Google', error);
    }
    throw error;
  }
};

export const getAccessToken = () => {
  if (typeof window !== 'undefined') {
    return localStorage.getItem('blogger_oauth_token');
  }
  return cachedAccessToken;
};

export const clearCachedAccessToken = () => {
  cachedAccessToken = null;
  if (typeof window !== 'undefined') {
    localStorage.removeItem('blogger_oauth_token');
  }
};

export const logoutGoogle = async () => {
  await signOut(auth);
  clearCachedAccessToken();
};
